// extracted by mini-css-extract-plugin
export default {"name":"search_brand__name--hcIu","link":"search_brand__link--CXNX"};